import React from 'react'
import styles from './Homepage.module.css'
import HomeHeroSection from '../../sections/HomeHeroSection/HomeHeroSection'
import WelcomeSection from '../../sections/WelcomeSection/WelcomeSection'
import RichTextSection from '../../sections/RichTextSection/RichTextSection'
import GalleryCarousel from '../../sections/GalleryCarousel/GalleryCarousel'
import OpenHoursSection from '../../sections/OpenHoursSection/OpenHoursSection'
import TestimonialsSection from '../../sections/TestimonialsSection/TestimonialsSection'
import HomeBannerSection from '../../sections/HomeBannerSection/HomeBannerSection'
import BrewsSection from '../../sections/BrewsSection/BrewsSection'
import EventsShowcase from '../../sections/EventsShowcase/EventsShowcase'
import ArtistGallery from '../../sections/ArtistGallery/ArtistGallery'

const Homepage = () => {
    return (
        <>
            <HomeBannerSection />
            <HomeHeroSection />
            <WelcomeSection />
            {/* <RichTextSection /> */}
            <EventsShowcase/>
            <ArtistGallery/>
            <BrewsSection />
            <OpenHoursSection />
            <GalleryCarousel />
            <TestimonialsSection />
        </>
    )
}

export default Homepage